import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Theme.withOpacity(Theme.white, 0.15),
    borderRadius: Theme.tileBorderRadius,
    overflow: 'hidden',
  },
});
